// extracted by mini-css-extract-plugin
export default {"feedback-form":"feedback-form","feedbackForm":"feedback-form","form-actions":"form-actions","formActions":"form-actions"};